import { render, staticRenderFns } from "./bulkMaterial.vue?vue&type=template&id=5cf2a29a&scoped=true"
import script from "./bulkMaterial.vue?vue&type=script&lang=js"
export * from "./bulkMaterial.vue?vue&type=script&lang=js"
import style0 from "./bulkMaterial.vue?vue&type=style&index=0&id=5cf2a29a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2a29a",
  null
  
)

export default component.exports